module.exports = __webpack_public_path__ + "static/media/pen.e4c5c090.svg";